import cn from 'classnames';
import * as React from 'react';

import { IconArrowLeftRight } from '@/components/ui/icons/IconArrowLeftRight';
import { IconChartBarPopular } from '@/components/ui/icons/IconChartBarPopular';
import { IconPennant } from '@/components/ui/icons/IconPennant';
import { IconRocket } from '@/components/ui/icons/IconRocket';
import { IconShieldCheck } from '@/components/ui/icons/IconShieldCheck';
import { IconUsers } from '@/components/ui/icons/IconUsers';
import { IconWorld } from '@/components/ui/icons/IconWorld';
import { IconZoomMoney } from '@/components/ui/icons/IconZoomMoney';

import s from './icons.module.scss';

type WrappedIcon = typeof IconPennant;

const DOCUMENT_ANALYSIS_ICON_BY_ID: Record<number, WrappedIcon> = {
  1: IconPennant,
  2: IconArrowLeftRight,
  3: IconShieldCheck,
  4: IconWorld,
  5: IconZoomMoney,
  6: IconChartBarPopular,
  7: IconUsers,
};

export const getDocumentAnalysisIcon = (
  id: number,
  variant: 'white' | 'gradient' = 'white',
  size: number = 20,
): React.ReactNode | null => {
  const IconComponent = DOCUMENT_ANALYSIS_ICON_BY_ID[id] ?? IconRocket;

  return <IconComponent className={cn(s.root__icon, variant === 'white' && s.root__icon_white)} size={size} />;
};
